/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TermsDto } from '../../models/terms-dto';

export interface TermsControllerGetActiveAll$Params {
}

export function termsControllerGetActiveAll(http: HttpClient, rootUrl: string, params?: TermsControllerGetActiveAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermsDto>>> {
  const rb = new RequestBuilder(rootUrl, termsControllerGetActiveAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TermsDto>>;
    })
  );
}

termsControllerGetActiveAll.PATH = '/api/terms';
